<template>
    <!-- pc推广海报 -->
    <!-- 导航栏：外包一层用于测量高度 -->
    <div ref="headWrap" class="zhai-head-wrap">
        <ZhaiHeadPC class="zhai-head"></ZhaiHeadPC>
    </div>

    <!-- 用 page-wrap 包住主体，让 padding-top 生效 -->
    <div class="page-wrap" :style="{ '--head-h': headH + 'px' }">
        <!-- 主体内容容器 -->
        <div class="container errong">
            <!-- 顶部标题条 -->
            <div class="container-fluid mt-3">
                <div class="row shengse pb-2 mt-2">
                    <div class="py-2 d-flex justify-content-between align-items-center">
                        <div class="lf go-back" @click="goBack">
                            <i class="fa fa-bullhorn"></i> 推广中心
                        </div>
                    </div>
                </div>
            </div>

            <!-- ✅ 新增：主体页头（与其它页面同位置） -->
            <div class="page-head">
                <div class="ph-left">
                    <div class="ph-title">推广海报</div>
                    <div class="ph-sub">选择模板生成海报，可下载保存用于推广</div>
                </div>

                <div class="ph-right">
                    <button class="btn-soft" :disabled="generating" @click="onGenerate">
                        <i class="fa fa-magic"></i> {{ generating ? "生成中..." : "一键生成" }}
                    </button>
                </div>
            </div>


            <!-- 主体：左右布局 -->
            <div class="pc-grid">
                <!-- 左侧：控制面板（无链接板块） -->
                <div class="panel">
                    <div class="panel-title">海报模板</div>

                    <!-- 模板选择 -->
                    <div class="thumbs">
                        <div
                                v-for="n in 7"
                                :key="n"
                                class="thumb"
                                :class="{ active: styleIndex === n }"
                                @click="styleIndex = n"
                                title="点击选择该模板"
                        >
                            <img :src="bgList[n - 1]" alt="" />
                            <div class="thumb-badge">{{ n }}</div>
                        </div>
                    </div>

                    <div class="divider"></div>

                    <!-- 生成按钮 -->
                    <button class="gen-btn" :disabled="generating" @click="onGenerate">
                        {{ generating ? "生成中..." : "生成推广海报" }}
                    </button>

                    <div class="save-tip" v-if="showSaveTip">如下载失败，可右键图片另存为或截图保存</div>

                </div>

                <!-- 右侧：大预览 -->
                <div class="panel preview-panel">
                    <div class="panel-title">预览</div>

                    <div class="preview-wrap">
                        <div class="poster poster-preview" ref="posterPreview">
                            <img class="poster-bg" :src="currentBg" alt="" />
                            <div class="qr qr-preview" v-if="qrDataUrl">
                                <img :src="qrDataUrl" alt="qr" />
                            </div>
                        </div>
                    </div>

                    <div class="muted preview-note">
                        提示：预览为自适应显示；实际生成图片为固定尺寸，清晰度更高。
                    </div>
                </div>
            </div>
        </div>

        <div class="gongxi2"></div>
        <ZhaiFootPC />
    </div>

    <!-- ✅ 隐藏：生成专用海报（固定尺寸，和手机端一致 750×1334） -->
    <div class="poster poster-gen" ref="posterGen" aria-hidden="true">
        <img class="poster-bg" :src="currentBg" alt="" />
        <div class="qr qr-gen" v-if="qrDataUrl">
            <img :src="qrDataUrl" alt="qr" />
        </div>
    </div>
    <!-- 生成结果弹窗 -->
    <!-- 生成中遮罩 -->
    <div v-if="generating" class="gen-mask" aria-hidden="true">
        <div class="gen-mask-card">
            <div class="gen-spinner"></div>
            <div class="gen-text">海报生成中…</div>
        </div>
    </div>

    <div v-if="posterModal.visible" class="poster-mask" @click.self="closePosterModal">
        <div class="poster-modal">
            <div class="modal-body">
                <div class="poster-img-wrap">
                    <img class="poster-img" :src="generatedImg" alt="poster" />
                </div>
            </div>
            <div class="modal-footer">
                <a class="btn-primary" :href="generatedImg" download="poster.png">
                    下载
                </a>
                <!-- 新增的关闭按钮 -->
                <button class="btn-ghost close-btn" @click="closePosterModal">关闭</button>
            </div>
        </div>
    </div>


</template>

<script>
    import ZhaiHeadPC from "../componentspc/ZhaiHeadPC";
    import ZhaiFootPC from "../componentspc/ZhaiFootPC";
    import html2canvas from "html2canvas";
    import QRCode from "qrcode";

    export default {
        name: "PPromotionPoster",
        components: { ZhaiHeadPC, ZhaiFootPC },
        data() {
            return {
                // 模板
                styleIndex: 1,

                // 生成状态
                generating: false,

                // 生成结果
                generatedImg: "",
                showSaveTip: false,
                posterModal: { visible: false },

                // 二维码
                qrValue: "",
                qrDataUrl: "",

                // 背景图
                bgList: [
                    require("../assets/pop1.jpg"),
                    require("../assets/pop2.jpg"),
                    require("../assets/pop3.jpg"),
                    require("../assets/pop4.jpg"),
                    require("../assets/pop5.jpg"),
                    require("../assets/pop6.jpg"),
                    require("../assets/pop7.jpg"),
                ],

                // 头部占位
                headH: 0,
                ro: null,
                mql: null,
                onMqlChange: null,
            };
        },
        computed: {
            currentBg() {
                const idx = Math.max(1, Math.min(7, Number(this.styleIndex || 1))) - 1;
                return this.bgList[idx];
            },
        },
        async mounted() {
            const fromQuery = (this.$route && this.$route.query && this.$route.query.link) || "";
            this.qrValue = fromQuery || "https://placeholder.example.com/?uid=xxxxxx";
            await this.makeQr();

            this.mql = window.matchMedia("(min-width: 768px)");

            const apply = () => {
                if (this.mql.matches) {
                    this.startObserveHeadHeight();
                    this.updateHeadHeight();
                } else {
                    this.stopObserveHeadHeight();
                    this.headH = 0;
                }
            };

            apply();

            this.onMqlChange = () => apply();
            if (this.mql.addEventListener) {
                this.mql.addEventListener("change", this.onMqlChange);
            } else {
                this.mql.addListener(this.onMqlChange);
            }

            window.addEventListener("resize", this.updateHeadHeight, { passive: true });
        },
        beforeUnmount() {
            this.stopObserveHeadHeight();
            window.removeEventListener("resize", this.updateHeadHeight);

            if (this.mql && this.onMqlChange) {
                if (this.mql.removeEventListener) {
                    this.mql.removeEventListener("change", this.onMqlChange);
                } else {
                    this.mql.removeListener(this.onMqlChange);
                }
            }
            document.body.style.overflow = "";
        },
        methods: {
            goBack() {
                if (window.history.length > 1) window.history.back();
                else window.location.href = "/Promotion";
            },
            // ====== QR ======
            async makeQr() {
                try {
                    const text = this.qrValue || "https://placeholder.example.com/";
                    this.qrDataUrl = await QRCode.toDataURL(text, {
                        margin: 0, // ✅ 去掉二维码自带外边距（quiet zone）
                        width: 420,
                        errorCorrectionLevel: "H",
                        color: {
                            dark: "#000000",
                            light: "#FFFFFF", // ✅ 强制白底（不要透明）
                        },
                    });
                } catch (e) {
                    console.error("二维码生成失败：", e);
                    this.qrDataUrl = "";
                }
            },
            // ====== 生成海报 ======
            openPosterModal() {
                this.posterModal.visible = true;
                document.body.style.overflow = "hidden";
            },
            closePosterModal() {
                this.posterModal.visible = false;
                document.body.style.overflow = "";
            },

            async onGenerate() {
                if (this.generating) return;
                this.generating = true;

                // 锁定页面
                document.body.style.overflow = "hidden";
                document.body.style.cursor = "wait";

                try {
                    if (!this.qrDataUrl) {
                        await this.makeQr();
                        await this.$nextTick();
                    }

                    const el = this.$refs.posterGen;
                    if (!el) {
                        alert("生成失败：posterGen 不存在");
                        return;
                    }

                    await this.$nextTick();
                    await new Promise((r) => requestAnimationFrame(() => r()));

                    const canvas = await html2canvas(el, {
                        useCORS: true,
                        backgroundColor: null,
                        scale: 2,
                    });

                    this.generatedImg = canvas.toDataURL("image/png");
                    this.showSaveTip = true;
                    this.openPosterModal();
                } catch (e) {
                    console.error(e);
                    alert("生成失败，请稍后重试");
                } finally {
                    this.generating = false;

                    // 如果没弹窗，才恢复滚动
                    if (!this.posterModal.visible) {
                        document.body.style.overflow = "";
                    }
                    document.body.style.cursor = "";
                }
            },
            // ====== 头部占位 ======
            startObserveHeadHeight() {
                if (this.ro || !this.$refs.headWrap) return;

                this.ro = new ResizeObserver(() => {
                    this.updateHeadHeight();
                });
                this.ro.observe(this.$refs.headWrap);
            },
            stopObserveHeadHeight() {
                if (this.ro) {
                    this.ro.disconnect();
                    this.ro = null;
                }
            },
            updateHeadHeight() {
                if (!this.mql || !this.mql.matches) return;
                if (!this.$refs.headWrap) return;

                const h = Math.ceil(this.$refs.headWrap.getBoundingClientRect().height || 0);
                if (h !== this.headH) this.headH = h;
            },
        },
    };
</script>

<style scoped>
    /* =========================================
       ✅ 只作用在 .container.errong 内的统一圆角 2px（可选）
       ========================================= */
    .container.errong {
        --ui-radius: 2px;
    }
    .container.errong .panel,
    .container.errong .thumb,
    .container.errong .btn-primary,
    .container.errong .btn-ghost,
    .container.errong .preview-wrap,
    .container.errong .gen-btn {
        border-radius: var(--ui-radius) !important;
    }

    /* 防止内容撑破圆角 */
    .container.errong .panel,
    .container.errong .preview-wrap {
        overflow: hidden;
    }

    /* ===== 固定头部：动态占位 ===== */
    @media (min-width: 768px) {
        .zhai-head-wrap {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            width: 100%;
            z-index: 1000;
        }
        .page-wrap {
            padding-top: var(--head-h, 0px);
        }
        .zhai-head {
            position: relative;
            width: 100%;
        }
    }
    @media (max-width: 767.98px) {
        .zhai-head-wrap {
            position: static;
        }
        .page-wrap {
            padding-top: 0;
        }
    }
    /* ✅ 新增：页头（与其它页面统一风格） */
    .page-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 14px 14px;
        background: #fff;
        border: 1px solid #f0f0f0;
        border-radius: var(--ui-radius);
        margin-top: 10px;
        margin-bottom: 12px;
    }

    .ph-left { min-width: 0; }
    .ph-title { font-size: 16px; font-weight: 900; color: #111; }
    .ph-sub { margin-top: 6px; font-size: 13px; color: #888; }
    .ph-right { display: flex; gap: 10px; flex-wrap: wrap; }

    .btn-soft {
        height: 36px;
        padding: 0 12px;
        border-radius: var(--ui-radius);
        border: 1px solid #eaeaea;
        background: #fafafa;
        font-size: 13px;
        cursor: pointer;
        color: #333;
        display: inline-flex;
        align-items: center;
        gap: 8px;
    }
    .btn-soft:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
    .btn-soft:active:not(:disabled) { opacity: 0.85; }
    .btn-soft .fa { margin-right: 0; color: #00c26f; }


    .page-wrap {
        min-height: calc(100vh - 120px);
    }

    .gongxi2 {
        height: 20px;
    }

    .errong {
        padding-left: 30px;
        padding-right: 30px;
    }

    .lf {
        font-weight: 900;
    }
    .go-back {
        cursor: pointer;
    }
    .muted {
        color: #999;
    }

    /* ===== 主体布局 ===== */
    .pc-grid {
        margin-top: 12px;
        display: grid;
        grid-template-columns: 420px 1fr;
        gap: 12px;
        align-items: start;
    }

    .panel {
        background: #fff;
        border: 1px solid #f0f0f0;
        padding: 16px;
    }

    .panel-title {
        font-size: 15px;
        font-weight: 900;
        color: #111;
        margin-bottom: 12px;
    }

    .divider {
        height: 1px;
        background: #f0f0f0;
        margin: 14px 0;
    }

    /* ===== 模板缩略图 ===== */
    .thumbs {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 10px;
    }
    .thumb {
        position: relative;
        border: 1px solid #f2f2f2;
        cursor: pointer;
        overflow: hidden;
        aspect-ratio: 3 / 4;
        background: #fafafa;
        transition: all 0.15s ease;
    }
    .thumb img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
    .thumb:hover {
        border-color: rgba(0, 194, 111, 0.35);
        box-shadow: 0 10px 22px rgba(0, 0, 0, 0.06);
        transform: translateY(-1px);
    }
    .thumb.active {
        border-color: rgba(0, 194, 111, 0.75);
        box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
    }
    .thumb-badge {
        position: absolute;
        left: 8px;
        top: 8px;
        width: 26px;
        height: 26px;
        border-radius: 999px;
        background: rgba(255, 255, 255, 0.85);
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 900;
        color: #e53935;
        border: 1px solid rgba(0, 0, 0, 0.05);
    }

    /* ===== 生成按钮 ===== */
    .gen-btn {
        width: 100%;
        height: 44px;
        border: 0;
        cursor: pointer;
        font-weight: 900;
        color: #fff;
        background: #ffd500;
        border-radius: 6px;
    }
    .gen-btn:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }

    .save-tip {
        margin-top: 12px;
        text-align: center;
        padding: 10px 12px;
        border-radius: 8px;
        background: rgba(255, 213, 0, 0.12);
        font-size: 13px;
        font-weight: 900;
        color: #e53935;
    }

    /* ===== 预览 ===== */
    .preview-panel {
        min-height: 520px;
    }
    .preview-wrap {
        width: 100%;
        border: 1px dashed #e6e6e6;
        background: #fafafa;
        padding: 12px;
    }

    .poster-preview {
        position: relative;
        width: 100%;
        height: 66vh;
        min-height: 520px;
        overflow: hidden;
        background: transparent;
    }
    .poster-bg {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: contain;
        object-position: top center;
    }

    /* 二维码 */
    .qr {
        position: absolute;
        aspect-ratio: 1 / 1;
        box-sizing: border-box;
        z-index: 10;
        background:#fff;
        padding: 2px;
    }

    .qr img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
    }

    /* 预览二维码：百分比定位（按实际背景图可调整） */
    .qr-preview {
        right: 25%;
        bottom: 0%;
        width: 14%;
    }

    /* ===== 生成画布（固定尺寸） ===== */
    .poster-gen {
        position: fixed;
        left: -99999px;
        top: 0;
        width: 750px;
        height: 1334px;
        overflow: hidden;
        background: transparent;
    }
    .poster-gen .poster-bg {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: top center;
    }
    /* 生成二维码：固定像素定位（精准落点） */
    .qr-gen {
        right: 5px;
        bottom: 0px;
        width: 200px;
    }

    /* 预览说明 */
    .preview-note {
        margin-top: 10px;
        font-size: 12px;
    }

    /* ===== 弹窗 ===== */
    .poster-mask {
        position: fixed;
        inset: 0;
        z-index: 99999;
        background: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 18px;
    }
    .poster-modal {
        width: 400px; /* 更小的宽度 */
        max-width: calc(100vw - 36px);
        background: #fff;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 24px 80px rgba(0, 0, 0, 0.35);
    }
    .modal-header {
        padding: 12px 14px;
        border-bottom: 1px solid #f0f0f0;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .modal-body {
        padding: 14px;
    }
    .poster-img-wrap {
        width: 100%;
        height: 100%; /* 修改为填满模态框 */
        overflow: hidden;
        background: #fafafa;
        border: 1px solid #f0f0f0;
    }
    .poster-img {
        width: 100%;
        height: 100%; /* 图片铺满模态框 */
        object-fit: cover; /* 使图片不变形，覆盖整个容器 */
    }
    /* 调整模态框底部按钮布局 */
    .modal-footer {
        padding: 12px 14px;
        border-top: 1px solid #f0f0f0;
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        position: relative; /* 为了让关闭按钮定位 */
    }

    /* 定位关闭按钮在左下角 */
    .close-btn {
        position: absolute;
        left: 14px; /* 调整距离左边的距离 */
        bottom: 12px; /* 调整距离底部的距离 */
    }


    /* 按钮 */
    .btn-primary {
        height: 38px;
        padding: 0 14px;
        border: none;
        color: #fff;
        font-weight: 800;
        cursor: pointer;
        background: linear-gradient(90deg, #00c26f, #19d184);
        display: inline-flex;
        align-items: center;
        gap: 8px;
        text-decoration: none;
    }
    .btn-ghost {
        height: 38px;
        padding: 0 12px;
        border: 1px solid #eaeaea;
        background: #fff;
        cursor: pointer;
        font-weight: 800;
        color: #333;
        display: inline-flex;
        align-items: center;
        gap: 8px;
    }
    .btn-ghost:hover {
        border-color: rgba(0, 194, 111, 0.35);
    }
</style>
